import { apiBaseQuery } from '@cognitranlimited/itis-web';
import { createApi } from '@reduxjs/toolkit/query/react';
export var ewdApi = createApi({
    reducerPath: 'ewdApi',
    baseQuery: apiBaseQuery(),
    endpoints: function (build) { return ({
        getLinkedEwdId: build.query({
            query: function (documentId) { return "documents/".concat(documentId, "/ewd"); }
        })
    }); }
});
